import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-315ee632"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main-banner-page",
  class: "position-relative page-header section-nav-smooth parallax blog-detail-header"
}
const _hoisted_2 = {
  id: "mapBox",
  class: "mt-3 mb-7"
}
const _hoisted_3 = { class: "row search-field" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Semua", -1))
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapAll = _resolveComponent("MapAll")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            id: "options",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.id_owner_spklu) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleJenisKendaraan && _ctx.handleJenisKendaraan(...args)))
          }, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMasterOwner, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item,
                value: item.id
              }, _toDisplayString(item.nama), 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.params.id_owner_spklu]
          ])
        ])
      ]),
      (_ctx.listSPKLU.length > 0)
        ? (_openBlock(), _createBlock(_component_MapAll, {
            key: 0,
            onMarkerClicked: _ctx.handleMarkerClicked,
            listMarker: _ctx.listSPKLU
          }, null, 8, ["onMarkerClicked", "listMarker"]))
        : _createCommentVNode("", true)
    ])
  ]))
}